module.exports = __webpack_public_path__ + "static/media/header_background.1457f44e.svg";